import { all, call, fork, put, takeEvery, getContext } from 'redux-saga/effects';
import { RegionConfigDashboardTypes } from './types';
import * as actions from './actions';
import { getAllRegionConfigs, getAllFilterRegionConfigs } from '../../api/api';
import { logout } from '../auth/actions';

function* handleGetAllRegionConfigs(action: ReturnType<typeof actions.getAllRegionConfigRecords>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetAllRegionConfigs');
      return;
    }
    const config = yield call(getAllRegionConfigs, idToken, action.payload.university, action.payload.pathway);
    yield put(actions.getAllRegionConfigRecordsSuccess(config));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getAllRegionConfigRecordsFailure(err.stack!));
    } else {
      yield put(actions.getAllRegionConfigRecordsFailure('An unknown error occurred.'));
    }
  }
}

function* handleGetAllFilterRegionConfigs(action: ReturnType<typeof actions.getAllFilterRegionConfigRecords>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetAllFilterRegionConfigs');
      return;
    }
    const config = yield call(getAllFilterRegionConfigs, idToken, action.payload.university, action.payload.pathway);
    yield put(actions.getAllFilterRegionConfigRecordsSuccess(config));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getAllFilterRegionConfigRecordsFailure(err.stack!));
    } else {
      yield put(actions.getAllFilterRegionConfigRecordsFailure('An unknown error occurred.'));
    }
  }
}

function* watchAllRegionConfigActions() {
  yield takeEvery(RegionConfigDashboardTypes.GET_ALL_REGION_CONFIGS, handleGetAllRegionConfigs);
  yield takeEvery(RegionConfigDashboardTypes.GET_ALL_FILTER_REGION_CONFIGS, handleGetAllFilterRegionConfigs);
}

function* ConfigSaga() {
  yield all([fork(watchAllRegionConfigActions)]);
}

export default ConfigSaga;
